import * as React from "react";

type ArrowRightThinProps = React.SVGProps<SVGSVGElement>;

const ArrowRightThin = React.forwardRef<SVGSVGElement, ArrowRightThinProps>(
  ({ className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className={className}
        {...props}
      >
        <path
          d="M3 12H21M21 12L12.5 3.5M21 12L12.5 20.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

ArrowRightThin.displayName = "ArrowRightThin";

export { ArrowRightThin };
